/** Zeitspanne in ms, ab der die Seite als veraltet gilt */
const STALE_THRESHOLD_MS = 60 * 60 * 1000

// const STALE_THRESHOLD_MS = 2 * 1000

const MODAL_NAME = 'session-guard'

/**
 * Erkennt lange Pausen, etwa wenn ein Tablet zum Dienstschluss gesperrt und
 * am nächsten Morgen wieder entsperrt wird, und weist per Modal auf einen
 * nötigen Neuladen der Seite hin.
 *
 * Hintergrund: Die Sicherheitstoken der Seite verlieren nach 24 Stunden ihre
 * Gültigkeit. Ein Neuladen erzeugt frische Token, ohne dass sich der
 * Mitarbeiter erneut anmelden muss.
 */
export default class Session_Guard {

    /** Singleton-Instanz */
    private static instance: Session_Guard

    /** Zeitpunkt, zu dem die Seite zuletzt nicht mehr sichtbar war */
    private hidden_since = 0

    /** Ob das Modal bereits geöffnet wurde */
    private is_open = false

    private constructor() {
        document.addEventListener( 'visibilitychange', this.on_visibility_change )
    }

    static get_instance(): Session_Guard {
        if ( undefined === Session_Guard.instance ) {
            Session_Guard.instance = new Session_Guard()
        }

        return Session_Guard.instance
    }

    /**
     * Merkt sich den Zeitpunkt, ab dem die Seite nicht mehr sichtbar ist,
     * und prüft beim Wiederaufwachen, ob zu viel Zeit vergangen ist.
     *
     * Auf iPadOS feuert das Event auch beim Sperren und Entsperren des
     * Geräts, deckt also den Fall "Tablet über Nacht weggelegt" mit ab.
     */
    private on_visibility_change = (): void => {
        if ( document.visibilityState === 'hidden' ) {
            this.hidden_since = Date.now()

            return
        }

        if ( this.hidden_since === 0 ) {
            return
        }

        const elapsed = Date.now() - this.hidden_since

        this.hidden_since = 0

        if ( elapsed > STALE_THRESHOLD_MS ) {
            this.show_modal()
        }
    }

    /**
     * Zeigt den Hinweis zum Neuladen der Seite.
     *
     * Ein bereits geöffnetes Modal wird von Fomantic automatisch geschlossen.
     * Das ist gewollt: Speichern wäre mit abgelaufenem Token ohnehin nicht
     * mehr möglich.
     */
    show_modal(): void {
        if ( this.is_open ) {
            return
        }

        const modal = app.get_modal( MODAL_NAME )

        if ( ! modal || modal.length === 0 ) {
            return
        }

        this.is_open = true

        modal
            .modal( {
                closable: false,
                onApprove: () => {
                    window.location.reload()

                    return false
                },
                onHidden: () => {
                    this.is_open = false
                },
            } )
            .modal( 'show' )
    }
}
